import styled from 'styled-components';
import { IconButton, Button } from '@material-ui/core';
import Link from '../Link';

const TextDiv = styled.div`
  font-size: 12px;
`;

const HeaderAction = ({
  icon,
  onClick,
  type,
  text,
  label,
  linkTo,
  redirectPath,
  redirect,
  dataTestId,
  disabled = false,
}) => {
  const componentMap = {
    iconButton: (
      <IconButton
        onClick={onClick}
        data-testid={dataTestId}
        color="secondary"
        disabled={disabled}
      >
        {icon}
      </IconButton>
    ),
    button: (
      <Button
        onClick={onClick}
        variant="text"
        data-testid={dataTestId}
        startIcon={icon}
        disabled={disabled}
      >
        {label}
      </Button>
    ),
    textAction: <TextDiv data-testid={dataTestId}>{text}</TextDiv>,
  };

  const component = componentMap[type];

  return linkTo && !disabled ? (
    <Link href={linkTo} redirectPath={redirectPath} redirect={redirect}>
      {component}
    </Link>
  ) : (
    component
  );
};

export default HeaderAction;
